import(/* webpackMode: "eager" */ "/home/runner/work/origin-map/origin-map/examples/nextjs/src/app/page.tsx");
